import styled, { css } from 'styled-components';

import Icon from 'components/Icon';
import { InputTag } from 'components/Input/styles';
import { shadows } from 'utils/style/animations';
import {
  black,
  blue,
  exactWhite,
  gray,
  green,
  lightGray,
  red,
} from 'utils/style/colors';
import {
  IEmailPanelProps,
  IRastechLogoProps,
  ITitleProps,
} from './LoginCard-type';

const shadowsAnimation = css`
  ${shadows} 0.5s ease-in-out forwards;
`;

const anniversaryAnimationTransition = '1s';

export const LoginCardBack = styled.div`
  padding: 4.19rem 2.45rem 2.34rem 2.45rem;
  background: ${exactWhite};
  backdrop-filter: blur(10px);
  box-shadow: 0 0 2rem -0.5rem #7c7b7b;
  border-radius: 2.75rem;
  z-index: 3;
`;

export const LineBetweenButtons = styled.div`
  width: 2px;
  background-color: ${black};
  margin-inline: 8.5px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  margin-top: 0.8rem;
  & > button {
    font-size: 0.75rem;
    border-radius: 0.9375rem;
    height: 3.125rem;
    flex: 1;
    padding-inline: 0;
    letter-spacing: 0;
  }
  & > * {
    border-radius: 3rem;
    & > span {
      font-weight: bolder;
      justify-content: center;
    }
  }
`;

export const Header = styled.div`
  display: block;
  text-align: center;
  align-items: center;
  justify-content: space-around;
`;

export const Title = styled.span<ITitleProps>`
  display: block;
  color: ${black};
  font-size: ${(props) => (props.smaller ? '1.2rem' : '1.8rem')};
  font-weight: 200;
  @media only screen and (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

export const RastechLogo = styled('img')<IRastechLogoProps>`
  width: ${(props) => (props.small ? '30px' : '90px')};
  height: ${(props) => (props.small ? '30px' : '90px')};
  opacity: 1;
  transition: all 0.5s ease;
  vertical-align: baseline;
  display: inline;
  object-fit: contain;
`;

export const SendCodeText = styled.div`
  color: ${green};
  & > div {
    display: inline-block;
    direction: ltr;
  }
`;
export const LoginText = styled.p`
  font-size: 0.75rem;
  font-weight: 200;
  transition: ${anniversaryAnimationTransition};
  color: var(--exact-white);
  overflow: hidden;
  margin-block: 1.01rem 0;
  height: ${({ showAnimation }) => {
    return showAnimation ? '4rem' : '0';
  }};
  & > p {
    font-weight: 300;
    margin-block: 0 0.53rem;
    & > b {
      font-weight: 500;
      font-weight: 500;
    }
  }
`;

export const Footer = styled('footer')`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  padding-bottom: ${(props) => (props.isPageFooterEnabled ? '11rem' : '1rem')};
`;

export const FixedFooter = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  min-height: 0;
  max-height: 11rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 100000000;
  gap: 0.75rem;
  /* width: calc(100% - 12rem); */
  margin-inline-start: auto;
  padding-bottom: 1rem !important;

  @media screen and (max-width: 800px) {
    width: 80%;
    margin: 0 auto;
  }
`;

export const FooterWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  @media screen and (max-width: 800px) {
    justify-content: center;
  }
`;

export const FooterItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  gap: 0.5rem;
`;

export const SquereFooterLogo = styled.img`
  height: 4rem !important;
  width: 4rem !important;
  border-radius: 1rem;
  padding: 1rem;
`;

export const FooterName = styled.div`
  text-align: center;
  font-size: 0.75rem;
  width: 4rem !important;
  height: 1.5rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.3rem;

  & > div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const BotSearch = styled.div`
  border-radius: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  background: #474a57;
  color: var(--exact-white);
  padding: 1rem 1.25rem;
  width: 70%;
  margin: 0 auto;

  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
  opacity: ${(props) => (props.visible ? '1' : '0')};

  transition: all 0.5s ease;

  @media screen and (max-width: 800px) {
    width: 100%;
  }
`;

export const BotLogo = styled.img`
  height: 1.5rem;
  width: 1.5rem;
  object-fit: contain;
`;

export const SymbolIcon = styled(Icon)`
  margin: unset !important;
  color: rgb(52, 200, 182);
  font-size: 17px;
  font-weight: 500 !important;
`;

export const Form = styled('form')`
  display: flex;
  flex-direction: column;
`;

export const Shadow = styled('span')`
  left: 0;
  color: #34c8b6;
  width: 100%;
  bottom: 0.5rem;
  height: 3rem;
  display: block;
  z-index: -1;
  position: absolute;
  box-shadow: 0px 0px 0px 0px;
  border-radius: 3rem;
`;

export const InputWrapper = styled.div`
  width: 100%;
  z-index: 1;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Symbol = styled('span')`
  right: 0;
  width: 100%;
  color: #999999;
  bottom: 0;
  height: 100%;
  display: flex;
  position: absolute;
  font-size: 15px;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  align-items: center;
  border-radius: 3rem;
  padding-right: 2.2rem;
  pointer-events: none;
`;

export const ShadowInput = styled(InputTag)`
  &&& {
    direction: ${(props) => props.theme.direction};
    text-align: ${(props) => props.theme.textAlign};
    padding: 0 1rem !important;
    border-radius: 0.5rem !important;
    height: 2.5rem;
    background-color: var(--exact-white) !important;
    border-color: ${lightGray} !important;
    color: ${black};
    font-size: 0.93rem;
    //&:-webkit-autofill {
    //  -webkit-box-shadow: 0 0 0 30px #051527 inset !important;
    //  -webkit-text-fill-color: #fff !important;
    //}
    ${(props) => {
      return props.err
        ? `
        color: ${red} !important;
        border-color: ${red} !important;
      `
        : '';
    }}

    &::placeholder {
      font-weight: 300 !important;
      font-size: 0.93rem;
    }
    &:disabled {
      color: ${lightGray};
      font-weight: 400;
    }
  }

  &[type='text'] {
    margin: 0.5rem 0 !important;
  }
  // &:focus + ${Shadow} {
  //   animation: ${shadowsAnimation};
  //   + ${Symbol} {
  //     color: #0070e0;
  //     padding-right: 1.5rem;
  //   }
  // }
`;

export const Hint = styled('span')`
  color: #0070e0;
  display: flex;
  font-size: 0.9rem;
  font-weight: bolder;
`;

export const SignUp = styled.div`
  margin-block: 1rem;
  display: flex;
  justify-content: center;
  & > span {
    &:first-child {
      color: ${gray};
    }
    &:last-child {
      color: ${blue};
      margin-right: 1rem;
    }
  }
`;

export const TextButton = styled.span`
  cursor: pointer;
  padding-inline-start: 0.5rem;
`;

export const EmailPanel = styled('span')<IEmailPanelProps>`
  display: ${(props) => (props.show ? 'inherit' : 'none')};
`;

export const HintBox = styled('div')`
  margin-top: 2rem;
  background-color: ${lightGray};
  border-inline-start: 3px solid ${black};
  display: flex;
  padding: 0.5rem;
  font-size: 0.8rem;
  align-self: center;
  font-weight: 400;
  border-left: 0.5rem;
`;

export const HintText = styled('div')`
  color: ${black};
  text-align: justify;
  white-space: pre-line;
  & > span:last-child {
    display: block;
    margin-top: 0.2rem;
  }
`;

export const ContentContainer = styled.div`
  position: absolute;
  top: 270px;
  right: 55px;
  left: 55px;
`;

export const MobileProfileContainerContentHolder = styled.div`
  min-height: ${(props) =>
    props.hasFixedFooter ? 'calc(100dvh - 40px)' : 'calc(100dvh)'};
  display: block;
  position: relative;
  background: var(--bg-image), var(--exact-white);
  background-attachment: scroll;

  /* @media screen and (min-width: 800px) {
    width: calc(100% - 12rem);
    margin-inline-start: auto;
  } */
`;

export const StickyPageFooterNavbar = styled.div`
  position: sticky !important;
  bottom: 1rem !important;
  height: 9rem !important;
  width: 80% !important;
  max-width: 1024px !important;
  padding: 1.25rem !important;
  margin: 0 auto !important;

  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  overflow: hidden !important;

  @media screen and (max-width: 600px) {
    width: 90% !important;
  }
`;

export const PageFooter = styled.div`
  max-width: 1024px;
  width: 100%;
  display: inline-grid;
  grid-auto-flow: column;
  grid-template-columns: 70px;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  @media screen and (max-width: 600px) {
    gap: 1.5rem;
  }
`;

export const PageFooterItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  cursor: pointer;

  & * {
    color: ${(props) =>
      props.isActive ? 'var(--primary)' : 'var(--text-secondary)'};
  }
`;

export const PageFooterLogoContainer = styled.div`
  height: 60px;
  width: 60px;

  padding: 0.5rem;
  border-radius: 20px;
  margin: 0 auto;
  background: var(--card);
`;

export const PageFooterLogo = styled.img`
  object-fit: contain;
  object-position: center;
`;

export const PageFooterContent = styled.div`
  display: flex;
  justify-content: center;
  background: var(--card);
  border-radius: 15px;
  padding: 0.25rem 0.5rem;
  font-size: 0.95rem;
`;
